(function () {
  'use strict';

  // Product page: gallery thumbnails, variant switching, quantity buttons
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var mainImage = root.querySelector('.js-main-image');
    var thumbs = root.querySelectorAll('[data-thumb]');

    function showImage(src) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        showImage(thumb.getAttribute('data-src'));
      });
    });

    var variantsEl = root.parentElement.querySelector('[data-variants-json]');
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (e) { variants = []; }

    var select = root.querySelector('[data-variant-select]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceWrap = root.querySelector('.product__price .price');
    var addButton = root.querySelector('[data-add-button]');

    if (select) {
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        var variant = variants.filter(function (v) { return v.id === id; })[0];
        if (!variant) return;

        if (priceCurrent) priceCurrent.innerHTML = variant.price;
        if (priceCompare) {
          if (variant.compare) {
            priceCompare.innerHTML = variant.compare;
            priceCompare.hidden = false;
          } else {
            priceCompare.innerHTML = '';
            priceCompare.hidden = true;
          }
        }
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!variant.compare);

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
        if (variant.image) showImage(variant.image);

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    root.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  });

  // Product recommendations are only filled when requested from Shopify's recommendations endpoint
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length > 0) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
})();
